export const FETCH_ORDER_STATUS_OVERVIEW_REQUEST = 'FETCH_ORDER_STATUS_OVERVIEW_REQUEST';
export const FETCH_ORDER_STATUS_OVERVIEW_SUCCESS = 'FETCH_ORDER_STATUS_OVERVIEW_SUCCESS';
export const FETCH_ORDER_STATUS_OVERVIEW_FAILURE = 'FETCH_ORDER_STATUS_OVERVIEW_FAILURE';

export const fetchOrderStatusOverviewRequest = () => ({
    type: FETCH_ORDER_STATUS_OVERVIEW_REQUEST,
});

export const fetchOrderStatusOverviewSuccess = (data) => ({
    type: FETCH_ORDER_STATUS_OVERVIEW_SUCCESS,
    payload: { data },
});

export const fetchOrderStatusOverviewFailure = (error) => ({
    type: FETCH_ORDER_STATUS_OVERVIEW_FAILURE,
    payload: { error },
});
